export class LookUpTables {
}

export class AllLookups {
  generalList: GeneralList[];
  multiLevelList: MultiLevelList[];
}

export class GeneralList {
  id: number;
  lookupTable: string;
}
export class ShippingProvAndMethods {
  id: string;
  deleteTypeId: number;
  isDeleted:boolean;
}
export class MultiLevelList {
  id: number;
  name: string;
}

//shipping providers get , add and update model start:
export class ShippingProvidersAndMethodsList {
  id: string='';
  name: string;
  trackingURL: string;
  active: boolean = false;
  totalRecords: number;
  isExpandable: boolean;
  accountNumber: string;
  isDomesticDefault: boolean;
  isInternationalDefault: boolean;
  isDeleted: boolean = false;
  shippingMethods: ShippingMethods[] = []
}

export class ShippingMethods {
  id: string='';
  shippingProvideId: string='';
  shippingProvideName: string;
  name: string;
  shippingDays: any;
  shippingAccount: string;
  createdByUserName: boolean;
  modifiedByUserName: boolean;
  dateCreated: string;
  dateModified: string;
  active: boolean;
  totalRecords: number;
  isDeleted: boolean;
  masterShippingProviderId: string='';
}
//shipping providers get , add and update model end:

export class WarehouseList {
  id: string='';
  address1: string;
  address2: string;
  address3: string;
  city: string;
  state: string;
  zipCode: string;
  phone: string;
  contactName: string;
  name: string;
  fullAddress: string;
  isDefault: boolean;
  active: boolean;
  isDeleted: boolean;
  isExpandable: boolean = false;
  createdAt: string;
  updatedAt: string;
  contactId: string;
  country: string;
  contactNumber: string;
}





export class NCMCodes {
  id: number;
  name: string;
  description: string;
  active: boolean;
  isDeleted: boolean;
  isExpandable: boolean = false;
}
export class NCMCodesID{
  id:number;
}
export class BillingTermsList {
  id: number;
  name: string;
  days: number;
  prePay: boolean = true;
  active: boolean;
  isDeleted: boolean;
}
export class UpdateDeleteBillingTermsList extends BillingTermsList {
  isDeleted: boolean;
}

export class VendorLeadTimeList {
  id: number;
  name: string;
  days: number;
  active: boolean;
  isDeleted: boolean;
}

export class UpdateDeleteVendorLeadTimeList extends VendorLeadTimeList {
  isDeleted: boolean;
}

export class CustomerLeadTimeList {
  id: number;
  name: string;
  days: number;
  active: boolean;
  isDeleted: boolean;
}

export class UpdateDeleteCustomerLeadTimeList extends CustomerLeadTimeList {
  isDeleted: boolean;
}

export class TagsList {
active      : boolean=false;
customer    : boolean=false;
externalId  : string='';
id          : string='';
isDeleted   : boolean=false;
lead        : boolean=false;
name        : string='';
prospect    : boolean=false;
vendor      : boolean=false;
}

export class CurrencyList {
  id: number;
  name: string;
  symbol: string;
  totalRecords: number;
  isDeleted: boolean;
  active: boolean;
  externalId: string;
}

export class LookupAddUpdateModel {
  id: number;
  categoryId: number;
  name: string;
  isActive: boolean = true;
  isDeleted: boolean;
}
export class ScopeAddUpdateModel {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
  externalId: string;
  isActive: boolean;
  isDeleted: boolean;
}

export class UpdateManufacturerStatus {
  manufacturerStatusId: number;
  manufacturerId: string;
  masterManufacturerChildId: string;
  active: boolean;
}

export class UpdateLookupValueStatus {
  id: number;
  isActive: boolean;
}

export class UpdateValueStatus {
  id: number;
  active: boolean;
}

export class PaginationBaseModel {
  sortColumn: string = '';
  sortDirection: string = '';
  pageNumber: number = 1;
  pageSize: number = 10;
  searchText: string = '';
  getAll: boolean = false;
}

export class LookupTabelModel extends PaginationBaseModel {
  id: number;
  sortedBy: string;
  lookupId: number;
}

export class LookupValueModel extends PaginationBaseModel {
  categoryId: string='';
}
export class ScopeModel extends PaginationBaseModel {
  id: number;
  sortedBy: string;
  isActive: boolean = true
  searchText: string;
  sortDirection: string;
  getAll: boolean=true
}


export class ShippingProvidersAndMethodsModel extends PaginationBaseModel {
  id: string;
}

export enum AccountType {
  Customer = 1,
  Vendor = 4,
  Prospect = 3,
  Lead = 2
}
export class UpdateSaleCommissionStatus{
  id: number;
  active: boolean;
  updateStatusTypeId: number ;
}
export class SaleCommissionPostModel{
  id: string ="";
  pageSize: number=0;
  pageNumber: number =0;
  searchText: string ='';
  sortDirection: string = '';
  sortColumn: string ='';
  getAll: boolean = true;
  typeId: number;
}
export class GetSaleCommissionResponse
{
  id: string ="";
  name: string;
  active: boolean;
  default: boolean;
  typeId: number ;
  isDeleted: boolean;
  isExpandable:boolean;
  commissionRange: SaleCommissionMapping[] =[]
}

export class SaleCommissionMapping {
  id: string ="";
  rate: any;
  active: boolean;
  isDeleted: boolean;
  isDefault: boolean;
  masterUsersCommissionId: string;
  minValue: string;
  maxValue: string;

}

export class DeletModel{
  id:string='';
}
export class DeleteSaleCommissionModel extends DeletModel{
  typeId:number;
}

export class InsertUpdateManufacturer {
  id: number
  manufacturerName: string
  active: boolean
  createdAt: string
  updatedAt: string
  externalId: string
  primaryManufacturerMapping: PrimaryManufacturerMapping[]=[];
}

export class PrimaryManufacturerMapping {
  id: number
  manufacturerId: number
  primaryManufacturerId: string
  active: boolean
  createdAt: string
  childName:string;
  updatedAt: string
  externalId: string
}




// model create for get and insert update for manufacturer tab
export enum ManufacturerType {
  PrimaryManufacturer = 1,
  SubManufacturer  = 2,
}

export class AddManufacturerModel {
  manufacturerId: string[] = [];
  manufacturerName: string = '';
  masterManufacturerChildId: string;
  isSubManufacturer: boolean = false;
}
export class UpdateManufacturerModel{
  manufacturerId: string[] = [];
  manufacturerName  : string='';
  masterManufacturerChildId    : string;
  manufacturerTypeId :number;
}


export class ManufacturerModel{
  masterManufacturerChildId:string[] = [];
  manufacturerName  : string='';
  manufacturerId    : string;
  isExpandable      : boolean=false;
  active          : boolean=false;
  isSubManufacturer: boolean=false;
}
export class ManufacturerVm {
 masterManufacturerChildId: string;
  manufacturerName  : string='';
  manufacturerId    : string='';
  isExpandable      : boolean=false;
  active          : boolean=false;
}